import { RootState } from "redux/rootReducer";

export const selectIsAddingRequest = (state: RootState) =>
  state.addRequest.loading;
export const selectAddRequestErrorMessage = (state: RootState) =>
  state.addRequest.error;
export const addRequestDataResponse = (state: RootState) =>
  state.addRequest.addRequestResponse;
